resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function HomepageSlideshow() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.extends = [_ResponsiveLayout];

    // Parameters
    this.arrows = true;
    this.seconds = 8;
    this.height = "100%";
    this.initialSlide = 0;
    this.autoPlay = true;
    this.showScroll = true;

    // Vars
    this._current = null;
    this._heightType = "px";
    this._height = 0;
    this._slideList = null;
    this._timer = null;

    this.init = function() {
        if (this.arrows) {
            $('<a href="#" class="icon-arrowright"></a>').prependTo(this.node);
            $('<a href="#" class="icon-arrowleft"></a>').prependTo(this.node);
        }
        $(this.node).css("display", "block");
        $(this.node).addClass("splash mogo-ui-homepage-slideshow");
        $(".content", this.node).css("visibility", "hidden");

        // Parse height input
        if (!isNaN(parseFloat(this.height))) this._height = parseFloat(this.height) + "";
        var heightType = (this.height + "").replace(this._height, "");
        if (heightType == "px" || heightType == "%" || heightType == "em")
            this._heightType = heightType;

        // Set slide list
        this._slideList = $("ul:first > li", this.node);
        for (var i = 0; i < this._slideList.length; i++) {
            $(this._slideList[i]).css("display", "none");
        }

        // Connections
        if (this._heightType == "%")
            this.registerResponsiveFunction($.proxy(this.resize, this), null, null);
        if (this.arrows) {
            $(".icon-arrowright", this.node).on("click", $.proxy(this.nextSlide, this));
            $(".icon-arrowleft", this.node).on("click", $.proxy(this.previousSlide, this));
        }
    };

    this.initAllReady = function() {
        $(".loader", this.node).css("display", "none");
        $("ul", this.node).css("display", "block");
        $(".content", this.node).css("visibility", "visible");


        // Show slide
        this.moveToSlide(this.initialSlide);
        $(".content", this.node).fadeIn(800, $.proxy(function() {
            this.resize();
        }, this));
    };

    this.nextSlide = function(e) {
        if (e) e.preventDefault;

        var newSlide = this._current + 1;
        if (newSlide >= this._slideList.length)
            newSlide = 0;
        this.moveToSlide(newSlide);
        return false;
    };

    this.previousSlide = function(e) {
        if (e) e.preventDefault;

        var newSlide = this._current - 1;
        if (newSlide < 0)
            newSlide = this._slideList.length - 1;
        this.moveToSlide(newSlide);
        return false;
    };

    this.moveToSlide = function(slideNum) {
        clearTimeout(this._timer);
        if (this._current != null) {
            $(this._slideList[this._current]).fadeOut(800);
        }
        $(this._slideList[slideNum]).fadeIn({duration:800, done:$.proxy(function() {
            if (this.autoPlay)
                this._setTimer();
        }, this)});
        this._current = slideNum;
    };

    this.resize = function() {
        $(this.node).css("height", "auto");
        var windowHeight = $(window).outerHeight() - 40; // 40 is footer height
        var resizedHeight = windowHeight * this._height/100;
        var contentList = $(".content, ul:first > li", this.node);
        for (var i = 0; i < contentList.length; i++) {
            resizedHeight = Math.max(resizedHeight, $(contentList[i]).outerHeight());
        }
        $(this.node).css("height", resizedHeight + "px");

        // Scroll indicator
        if (this.showScroll && $(window).scrollTop() <= 250) {
            if (resizedHeight <= windowHeight) {
                if ($(".scroll-indicator", this.node).length < 1) {
                    // Create scroller
                    $('<a href="#" class="scroll-indicator strong">Scroll<br><span class="icon-arrowdown"></span></a>').appendTo(this.node);
                    $(".scroll-indicator", this.node).on("click", $.proxy(this._onClickScroll, this));
                    $(window).on("scroll", $.proxy(this._onScroll, this));
                }
                // Show scroll indicator
                $(".scroll-indicator").fadeIn(500);
            } else {
                $(".scroll-indicator").css("display", "none");
            }
        }
    };

    this._setTimer = function() {
        setTimeout($.proxy(this.nextSlide, this), this.seconds * 1000);
    };

    this._onClickScroll = function(e) {
        e.preventDefault();
        $("html, body").animate({scrollTop: 500}, {easing: "easeOutQuart", duration: 1350, done: $.proxy(function() {
            $(".scroll-indicator", this.node).fadeOut(350);
        }, this)});
    };

    this._onScroll = function() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 250) {
            $(".scroll-indicator", this.node).fadeOut(350);
        }
    };
}